/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1TagTagidLangs202,
  PostApiV1TagTagidLangs400,
  PostApiV1TagTagidLangs401,
  PostApiV1TagTagidLangs404,
  PostApiV1TagTagidLangs409,
  PostApiV1TagTagidLangs500,
  PostApiV1TagTagidLangsMutationRequest,
  PostApiV1TagTagidLangsMutationResponse,
  PostApiV1TagTagidLangsPathParams,
} from "../../types/tagIdiomasController/PostApiV1TagTagidLangs.ts";
import { createTagLangRequestViewModelSchema } from "../createTagLangRequestViewModelSchema.ts";
import { tagLangViewModelSchema } from "../tagLangViewModelSchema.ts";

export const postApiV1TagTagidLangsPathParamsSchema = z.object({
  tagId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1TagTagidLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1TagTagidLangs202Schema = z.lazy(
  () => tagLangViewModelSchema,
) as unknown as ToZod<PostApiV1TagTagidLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1TagTagidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1TagTagidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1TagTagidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1TagTagidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1TagTagidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1TagTagidLangs404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1TagTagidLangs409Schema =
  z.any() as unknown as ToZod<PostApiV1TagTagidLangs409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1TagTagidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1TagTagidLangs500>;

export const postApiV1TagTagidLangsMutationRequestSchema = z.lazy(
  () => createTagLangRequestViewModelSchema,
) as unknown as ToZod<PostApiV1TagTagidLangsMutationRequest>;

export const postApiV1TagTagidLangsMutationResponseSchema = z.lazy(
  () => postApiV1TagTagidLangs202Schema,
) as unknown as ToZod<PostApiV1TagTagidLangsMutationResponse>;
